<template>
  <div class="page" id="login">



    <!--内容 BEGIN-->
    <div class="wrapper" id="wrapper">
      <!--首屏 BEGIN-->
      <div class="layer layer1">
        <!--首屏标题-->
        <div class="title"></div>
        <!--登录图标-->
        <div class="startbtn" @click="$router.push('/')"></div>
        <!--底部横条-->
        <div class="stripe"></div>
        <!--底部人物-->
        <div class="person"></div>
      </div>
      <!--首屏 END-->
    </div>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>